<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2020-02-14 16:52:36
 * @LastEditTime: 2020-03-15 10:55:32
 -->
<template>
  <!-- 外链的初始页面，用于分发到不同的页面 -->
  <component
    :is="curComponent"
    ref="common"
    :data="data"
  />
</template>

<script>
import extend from 'extend'
import _$ from 'js/api/getdata'
import bsInvalid from 'components/business/link/invalid/index.vue' // 外链失效页面
import bsLfile from 'components/business/link/lfile/index.vue' // 文件外链的展示页面
import bsLfolder from 'components/business/link/lfolder/index.vue' // 文件夹外链的展示页面
import bsSmartshare from 'components/business/link/smartshare/index.vue' // 文件夹外链的展示页面
import bsPreLogin from 'components/business/preLogin/index.vue' // 文件夹外链的展示页面

export default {
  components: {
    bsInvalid,
    bsLfile,
    bsLfolder,
    bsSmartshare,
    bsPreLogin,
  },
  data() {
    return {
      curComponent: '',
      data: {},
    }
  },
  created() {
    // 初始化
    this.init()
  },
  methods: {
    /**
     * 初始化外链
     *     '10001': 'bsInvalid',查不到外链信息
     *     '10002': 'bsInvalid',正在已经审核不允许通过
     *     '10003': 'bsInvalid',外链过期
     *     '10004': 'bsInvalid',审批被拒绝
     *     '10005': 'bsInvalid',发外链的账号已经过期
     *     '10006': 'bsInvalid',用户状态不正常
     *     '10007': 'bsInvalid',该外链没有开启外链功能
     *     '10008': '', 内链但没有登录
     *     '10009': '', 内链已经登录但当前用户和外链创建者不在同一企业
     *     '10000': '', 所有权限校验完成
     */
    async init() {
      // 暂不考滤手机的的外链预览
      // 20200220与后端交流新增加接口不同接口返回不现的错误信息
      // 暂时整理需要的报错信息后端接口没有值，保证前端逻辑正常进行，取导航id为返回值参考
      const param = this.$route.params || {}
      const { neid } = param
      const url = _$.formatUrl(`/delivery/actionView/${neid}`)
      // 请求外链信息并返回相应的状态
      let d = await _$.getData(url)
      d = d.data
      // 将页签的title设置为用户自定义的title(兼容外链页面未登录的情景)
      document.title = (d.data || {}).title;
      // 组件内数据的格式
      const inData = {
        deliverycode: param.neid,
        ext: { code: d.code },
      }
      inData.ext = extend(inData.ext, d.data)
      this.data = inData

      // 显示异常页面
      // 异常页面分两类
      // 1. 外链效页面
      // 2. 外链无权限10009
      const invalidCodes = ['10001', '10002', '10003', '10004', '10005', '10006', '10007', '10009']
      if (invalidCodes.indexOf(d.code) !== -1) {
        this.curComponent = 'bsInvalid'
        return
      }
      // 内链没有登录需要跳登录页面
      if (d.code === '10008') {
        this.$router.push({ path: `/link/user/prelogin/${neid}`, query: {body: this.data} })
        return
      }

      // 显示目录页面
      if (d.data.type === 'dir') {
        this.curComponent = 'bsLfolder'
        return
      }

      // 显示普通文件，和内链已经登录完成的文件
      this.curComponent = 'bsLfile'
    },
  },
}
</script>
